// Locale-aware date formatting, driven by the SITE's own language choice
// (i18n.language), not the raw browser/OS locale — a user who picked the
// Italian UI wants Italian date formatting (17/08/2026) even if their
// phone's region happens to be set to en-US; found 2026-08-28 showing
// American dates (8/17/2026) on an Italian interface, hardcoded to
// toLocaleDateString('en-US') regardless of the chosen UI language.
//
// English deliberately does NOT force 'en-US' back — passing `undefined`
// lets the browser use the visitor's own regional format (en-GB's
// 17/08/2026 for a UK visitor, en-US's 8/17/2026 for a US one, etc.),
// matching "formato locale" for English speakers rather than picking one
// English-speaking country's convention for all of them.
function localeFor(lang) {
  if (lang === 'it') return 'it-IT';
  if (lang === 'es') return 'es-ES'; // 2026-09-16: spagnolo, virgola decimale e giorno/mese/anno
  if (lang === 'fr') return 'fr-FR'; // 2026-09-17: francese
  if (lang === 'de') return 'de-DE'; // 2026-09-18: tedesco
  return undefined;
}

export function formatDate(date, lang, options) {
  return new Date(date).toLocaleDateString(localeFor(lang), options);
}

export function formatDateTime(date, lang, options) {
  return new Date(date).toLocaleString(localeFor(lang), options);
}

export function formatTime(date, lang, options) {
  return new Date(date).toLocaleTimeString(localeFor(lang), options);
}
